import React from "react";
import { observer } from "mobx-react";

type Props = {
  microdata: Entity.Meta["microdata"];
};

const Microdata: React.FC<Props> = ({ microdata }) => {
  if (!microdata) return null;
  return <div dangerouslySetInnerHTML={{ __html: microdata }} />;
};

export default observer(Microdata);
